import { render } from "./RegistroActualizaciones.vue?vue&type=template&id=23a7ac63&scoped=true"
import script from "./RegistroActualizaciones.vue?vue&type=script&lang=js"
export * from "./RegistroActualizaciones.vue?vue&type=script&lang=js"

import "./RegistroActualizaciones.vue?vue&type=style&index=0&id=23a7ac63&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a7ac63"]])

export default __exports__